import MantineGrid from '../../../UI/MantineGrid/ManiteGrig';
import { useTranslation } from 'react-i18next';

const GridProvider = ({ data = [] }) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'orderNumber',
      headerName: t('orderNumber'),
      // size: 300,
    },
    {
      field: 'machineType',
      headerName: t('machineType'),
      // size: 200,
    },
    {
      field: 'technology',
      headerName: t('technology'),
      // size: 200,
    },
    {
      field: 'reportedBy',
      headerName: t('reportedBy'),
      // size: 150,
    },
  ];
  const columnsDetail = [
    {
      field: 'status',
      headerName: t('status'),
      // size: 300,
    },
    {
      field: 'orderType',
      headerName: t('orderType'),
      // size: 200,
    },
    {
      field: 'billingType',
      headerName: t('billingType'),
      // size: 200,
    },
    {
      field: 'title',
      headerName: t('title'),
      // size: 150,
    },
    {
      field: 'notificationDate',
      headerName: t('notificationDate'),
      // size: 150,
    },
  ];
  return (
    <div
      style={{
        marginTop: '10px',
        height: 'fit-content',
        width: '99%',
      }}
    >
      <MantineGrid
        enableTableDetail
        columns={columns}
        data={data}
        columnsDetail={columnsDetail}
        subRows="subRows"
      />
      {/* <MuiGrid data={data} loading={loading} columns={columns} /> */}
    </div>
  );
};

export default GridProvider;
